import React from 'react';
import { Morale } from '../../domain/entities';
import { useUI } from '../../contexts/UIContext';
import './MoraleBadge.css';

export const getMoraleTier = (morale: Morale): { label: string, className: string, description: string } => {
    switch (morale) {
        case 'Ecstatic': return { label: 'Elated', className: 'morale-elated', description: 'Feeling on top of the world' };
        case 'Happy': return { label: 'Happy', className: 'morale-happy', description: 'Pleased with their current situation' };
        case 'Content': return { label: 'Content', className: 'morale-content', description: 'No issues, feeling fine' };
        case 'Unhappy': return { label: 'Unhappy', className: 'morale-unhappy', description: 'Has some concerns' };
        case 'Furious': return { label: 'Furious', className: 'morale-furious', description: 'Extremely unhappy and may cause issues' };
        default: return { label: 'Content', className: 'morale-content', description: 'No issues, feeling fine' };
    }
};

interface MoraleBadgeProps {
    morale: Morale;
}

export const MoraleBadge: React.FC<MoraleBadgeProps> = ({ morale }) => {
    const { openMoraleInfoModal } = useUI();
    const tier = getMoraleTier(morale);
    const title = `Morale: ${morale} (${tier.description}). Click for more info.`;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        openMoraleInfoModal(morale);
    };

    return (
        <button className="morale-badge-button" onClick={handleClick} title={title}>
            <span className={`morale-badge ${tier.className}`}>
                {tier.label}
            </span>
        </button>
    );
};
